export const aboutData = {
    title: "Who I am",
    description1: "My name's Boniface Kamau. I'm a passionate software developer based in Nairobi, Kenya.",
    description2: "My journey as a software developer began with a curiosity for technology and a desire to build impactful solutions. Over the years, I have worked on various projects, collaborating with cross-functional teams to deliver robust and user-friendly applications. I take pride in my ability to transform complex ideas into clean, maintainable code.",
    image: 1
}